import { render, staticRenderFns } from "./UpcommingCalendars.vue?vue&type=template&id=20969b54&scoped=true&"
import script from "./UpcommingCalendars.vue?vue&type=script&lang=js&"
export * from "./UpcommingCalendars.vue?vue&type=script&lang=js&"
import style0 from "./UpcommingCalendars.vue?vue&type=style&index=0&id=20969b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20969b54",
  null
  
)

export default component.exports